import axios from '../base.js'
export default class SBTS {
  // 机柜数量
  static async reqGetjgslData() {
    let res = await axios.get('./data/SBTS/jgslData.json');
    return res.data;
  }
  // 设备数量
  static async reqGetsbslData() {
    let res = await axios.get('./data/SBTS/sbslData.json');
    return res.data;
  }
  // 设备类型占比
  static async reqGetsblxzbData() {
    let res = await axios.get('./data/SBTS/sblxzbData.json');
    return res.data;
  }
  // 告警列表
  static async reqGetgklbData() {
    let res = await axios.get('./data/SBTS/gklbData.json');
    return res.data;
  }
  // 环境监测
  static async reqGethjjcData() {
    let res = await axios.get('./data/SBTS/hjjcData.json');
    return res.data;
  }
  // 能效监测
  static async reqGetnxjcData() {
    let res = await axios.get('./data/SBTS/nxjcData.json');
    return res.data;
  }
}